export const marketReducer = (state = [], action) => {
  switch (action.type) {
    case "INIT":
      return action.payload;

    default:
      return state;
  }
};

export const CoinListReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_COINS_LIST":
      return action.payload;

    default:
      return state;
  }
};
